var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavPersonal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5 15C5.05305 15 5.10772 15 5.16409 15H10M5 15C4.17644 14.9993 3.74445 14.989 3.40983 14.8185C3.09623 14.6587 2.84144 14.4031 2.68166 14.0895C2.5 13.733 2.5 13.2669 2.5 12.3335V7.66683C2.5 6.73341 2.5 6.26635 2.68166 5.90983C2.84144 5.59623 3.09623 5.34144 3.40983 5.18166C3.76635 5 4.23341 5 5.16683 5H14.8335C15.7669 5 16.233 5 16.5895 5.18166C16.9031 5.34144 17.1587 5.59623 17.3185 5.90983C17.5 6.266 17.5 6.73249 17.5 7.66409V12.3359C17.5 13.2675 17.5 13.7333 17.3185 14.0895C17.1587 14.4031 16.9031 14.6587 16.5895 14.8185C16.2333 15 15.7675 15 14.8359 15H10M5 15C5.00003 14.0795 6.11931 13.3333 7.5 13.3333C8.88071 13.3333 10 14.0795 10 15M5 15C5 15 5 14.9999 5 15ZM15 11.6667H11.6667M15 9.16667H12.5M7.5 10.8333C6.57953 10.8333 5.83333 10.0871 5.83333 9.16667C5.83333 8.24619 6.57953 7.5 7.5 7.5C8.42047 7.5 9.16667 8.24619 9.16667 9.16667C9.16667 10.0871 8.42047 10.8333 7.5 10.8333Z",
    stroke: "#757575",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavPersonal);
export default __webpack_public_path__ + "static/media/nav-personal.0ccc16b85826ca49abd2a29b4140f604.svg";
export { ForwardRef as ReactComponent };